module.exports = __webpack_public_path__ + "media/images/yellow_circle_chipped-f8839331dcfb2621d31462a6ba86ff08.svg";